<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
        <div class="w-100">
			<part1_admin_btns
				:flds="flds"
				@click="(e)=>{$emit('click', e);}"
				v-if="$localStorage.get('user').username.role==3" 
				class="d-flex" 
				style="justify-content: space-between;" 
			/>
			<div class="p-3 border-15" v-else>
				<div >
					<label class="w-100 pointer" style="font-size: 14px; color:#000;">
						<input type="checkbox" v-model="checkbox" class="d-none" />
						راهنمای پشتیبانی آنلاین
						<img 
						:src="require('../../assets/img/arrow_green.svg')"
						class="float-left"
						:style="'rotate: '+(checkbox ? '0' : '180')+'deg;'"
						style="margin-top: 8px;"
						/>
					</label>
				</div>
				<p style="color: #676767; font-size: 14px;" v-if="checkbox">
					در صورتی که در رابطه با بخش‌های مختلف ایزی تیک سوالی دارید، قبل از تماس با پشتیبانی می‌توانید سوالات متداول را مطالعه نمایید.
					<br>
					در صورتی که سوال شما در بخش سوالات متداول پاسخ داده نشده بود، با ما از طریق ارسال تیکت و یا تماس با پشتیبانی در تماس باشید.
				</p>
			</div>
			<hr />
			<p>
				فهرست تیکت ها
			</p>
			<!-- ********************************************************** -->
			<div class="col-6" style="float: inline-end;" v-if="$localStorage.get('user').username.role==3">
				<div>
					<div class="" style="display: flex; flex-direction: row-reverse; margin-bottom: 28px; margin-top: 28px;">
						<div class="text-14 text-success">
							فیلتر ها
						</div>
						<div>
							<span class="text-14 text-gray pointer" style="margin-left: 40px;" @click="clean_filter()">
								<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M2.81817 2.81524C3.01973 2.61367 3.34652 2.61367 3.54808 2.81524L8.00033 7.26746L12.4526 2.81524C12.6541 2.61367 12.9809 2.61367 13.1825 2.81524C13.3841 3.0168 13.3841 3.34359 13.1825 3.54515L8.73026 7.9974L13.1825 12.4497C13.3841 12.6512 13.3841 12.978 13.1825 13.1795C12.9809 13.3811 12.6541 13.3811 12.4526 13.1795L8.00033 8.72733L3.54808 13.1795C3.34652 13.3811 3.01973 13.3811 2.81817 13.1795C2.6166 12.978 2.6166 12.6512 2.81817 12.4497L7.27039 7.9974L2.81817 3.54515C2.6166 3.34359 2.6166 3.0168 2.81817 2.81524Z" fill="#676767"/>
								</svg>	
								حذف فیلترها
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 mb-3 d-flex direction-row-reverse justify-content-end" v-if="$localStorage.get('user').username.role==3" style="margin-bottom: 28px;">
				<select class="form-control mr-1" @change="(e)=>{set_filter(e.target.value, 'importances')}" v-model="$route.query.importances">
					<option value="" hidden>درجه اهمیت</option>
					<option value="">همه</option>
					<option v-for="(imp, i) in importances" :key="i" :value="imp.name" >
						{{ imp.name }}
					</option>
				</select>
				<select class="form-control mr-1" @change="(e)=>{set_filter(e.target.value, 'CRM')}" v-model="$route.query.CRM" v-if="$localStorage.get('user').username.access_level==0">
					<option value="" hidden>کارشناس CRM</option>
					<option value="0" hidden>کارشناس CRM</option>
					<option value="0">همه</option>
					<option 
						v-for="(crm, i) in flds.data.CRMS" :key="i"
						:value="crm.id"
					>
						{{ crm.fullname }}
					</option>
				</select>
				<inputcalender_filter 
				:date="$route.query.date"
				label="" 
				placeholder="تاریخ ایجاد آخرین تیکت"
				leading=""
				input_style="border: 1px solid #d2d2e4;"
				class="mr-1"
				:img="require('../../assets/img/Calendar.svg')"
				@inputdate="(e)=>{set_filter(e, 'date')}"
				/>
			</div>
			<!-- ********************************************************** -->


			<div class="text-center">
				<img 
					:src="require('../../assets/img/Letter.svg')"
				/>
				<br/>
				<p class="mt-3 text-center">
					<b class="" style="color: #000; font-size: 14px;">
						تیکتی برای شما ثبت نشده است
					</b>
				</p>
				<p class="text-center" style="color: #676767; font-size: 12px;"  v-if="$localStorage.get('user').username.role!=3">
					تیکت‌های شما از زمان ثبت تا پایان یافتن، در این قسمت نمایش داده می‌شوند.
				</p>
				<p class="text-center" style="color: #676767; font-size: 12px;"  v-else>
					تیکیت های شما از زمان ثبت کاربران، در این قسمت نمایش داده می‌شود.
				</p>
				<router-link to="/ticket/create" v-if="$localStorage.get('user').username.role != 3">
					<btn
					class="pt-3"
					textClass="m-auto"
					:img="require('../../assets/img/+.svg')"
					text="تیکت جدید"
					dir_btn="ltr"
					@clickMe="sav()"
					/>
				</router-link>
				<br>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import part1_admin_btns from  "./part1_admin_btns.vue";
		import inputcalender_filter from  "../../UI/calendar/inputcalender_filter.vue";
		import * as read_crm_json from  "./read_crm.json";
		import * as subjects_teacher_json from  "./subjects_teacher.json";
		import * as subjects_user_json from  "./subjects_user.json";
		import * as importances_json from  "./importances.json";

		export default {
			name: 'part1_empty',
			data(){
				return {
					checkbox: false,
					read_crm: read_crm_json.default,
					subjects: ((this.$route.query.knd_user=='users') ?  subjects_user_json.default: subjects_teacher_json.default) ,
					importances: importances_json.default
				}
			},
			components: {
				btn,
				part1_admin_btns,
				inputcalender_filter
			},
			props: ["flds"],
			mounted(){
			},
			methods:{
				clean_filter(){
					this.$router.push({query: {
						CRM : '0',
						date : '',
						importances: "",
						search: "",
						page: '1',
						search: '',
						subjects: '',
						knd_user: this.$route.query.knd_user
					}
				});
				this.$emit("click", "");

				},
				set_filter(e, set){
					let query = [];
                    for (let q in this.$route.query) {
						if (q != set) {
							query[q] = this.$route.query[q];
                        }
                    }
					query.page = 1;
					query[set] = e;
                    this.$router.push({query: query});


					this.$emit("click", "");
				},
				
			}
		}
	</script>
<style scoped>
select{
	background-color: #F5FAFD;
	border-radius: 10px;
	width: 124px;
}

</style>
